<template>
  <div id="app-404">
    <!-- 顶栏 -->
    <HeaderMain></HeaderMain>
    <img alt="404" src="https://img.blendermagic.cn/new/404.png">
    <el-button type="primary" id="app-404-button" v-on:click="$router.push('/')">
      返回主页
    </el-button>
  </div>
</template>

<script>

import HeaderMain from "@/views/share/HeaderMain";

export default {
  name: "e404",
  components: {
    HeaderMain
  },
  mounted() {
    document.title = "斑斓魔法CG-404";
  },
}
</script>

<style scoped>

#app-404 {
  margin: auto;
  text-align: center;
}

#app-404-button {
  display: table-row;
  margin: auto;
  border-radius: 0;
  background: #ff8a00;
  border: #ff8a00;
  width: 150px;
}

</style>